// extracted by mini-css-extract-plugin
export default {"AccordionList":"zMOQd_ez6p7jerBWC5K0","Item":"Cd6jXZsn6RIsUsc8h6a1"};